import { render } from "./Loading.vue?vue&type=template&id=4e9b8d1c"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
script.render = render

export default script